// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__3gK7f","inputDescription":"styles_inputDescription__1fEY7"};